import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
  ViError,
} from '@vi-iot/client';
import { DiagStackConnectionProperties } from '../remote-diagnostics';

export namespace VddDetailsListActions {
  export const ClearVdd = createAction(
    '[VDD DETAILS LIST] Clear vdd',
    props<{ vddName: string; logicalLinkName: string }>()
  );

  export const GetVddMetadataAttempt = createAction(
    '[VDD DETAILS LIST] Get vdd metadata attempt',
    props<{ vddName: string; gatewaySerial: string; logicalLinkName: string }>()
  );
  export const GetVddMetadataSuccess = createAction(
    '[VDD DETAILS LIST] Get vdd metadata success',
    props<{
      vddName: string;
      logicalLinkName: string;
      metadata: RemoteDiagnosticsVddRootMetadataResponse;
    }>()
  );
  export const GetVddMetadataFailed = createAction(
    '[VDD DETAILS LIST] Get vdd metadata failed',
    props<{ vddName: string; logicalLinkName: string; error: unknown }>()
  );

  export const GetVddStructureAttempt = createAction(
    '[VDD DETAILS LIST] Get vdd structure attempt',
    props<{ vddName: string; gatewaySerial: string; logicalLinkName: string }>()
  );
  export const GetVddStructureSuccess = createAction(
    '[VDD DETAILS LIST] Get vdd structure success',
    props<{
      vddName: string;
      logicalLinkName: string;
      structure: DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]>;
    }>()
  );
  export const GetVddStructureFailed = createAction(
    '[VDD DETAILS LIST] Get vdd structure failed',
    props<{ vddName: string; logicalLinkName: string; error: unknown }>()
  );

  export const GetVddSingleValueAttempt = createAction(
    '[VDD DETAILS LIST] Get vdd single value attempt',
    props<{ vddName: string; gatewaySerial: string; logicalLinkName: string }>()
  );
  export const GetVddSingleValueSuccess = createAction(
    '[VDD DETAILS LIST] Get vdd single value success',
    props<{
      vddName: string;
      logicalLinkName: string;
      singleRead: RemoteDiagnosticsSuccessResponseData;
    }>()
  );
  export const GetVddSingleValueFailed = createAction(
    '[VDD DETAILS LIST] Get vdd single value failed',
    props<{ vddName: string; logicalLinkName: string; error: unknown }>()
  );

  export const GetStructureAndValueForVddListAttempt = createAction(
    '[VDD DETAILS LIST] Get structure and value for list of vdd attempt',
    props<{ vddNames: string[]; gatewaySerial: string; logicalLinkName: string }>()
  );
  export const GetMetadataAndStructureAndValueForVddListAttempt = createAction(
    '[VDD DETAILS LIST] Get metadata, structure and value for list of vdd attempt',
    props<{ vddNames: string[]; gatewaySerial: string; logicalLinkName: string }>()
  );
  export const GetStructureAndValueAttempt = createAction(
    '[VDD DETAILS LIST] Get structure and value for vdd attempt',
    props<{ vddName: string; gatewaySerial: string; logicalLinkName: string }>()
  );
  export const GetMetadataAndStructureAndValueAttempt = createAction(
    '[VDD DETAILS LIST] Get metadata, structure and value attempt',
    props<{ vddName: string; gatewaySerial: string; logicalLinkName: string }>()
  );

  export const writeVddSingleValue = createActionGroup({
    source: 'VDD DETAILS LIST Write single value',
    events: {
      attempt: props<{ gatewaySerial: string; vddName: string; logicalLink: string }>(),
      success: props<{
        diagStackConnectionProperties: DiagStackConnectionProperties;
        vddRawSingleReadValues: RemoteDiagnosticsSuccessResponseData;
        vddName: string;
        logicalLink: string;
      }>(),
      failed: emptyProps(),
    },
  });

  export const verifyWrittenVddSingleValue = createActionGroup({
    source: 'VDD DETAILS LIST Verify written single value',
    events: {
      attempt: props<{
        diagStackConnectionProperties: DiagStackConnectionProperties;
        vddRawSingleReadValues: RemoteDiagnosticsSuccessResponseData;
        vddName: string;
        logicalLink: string;
      }>(),
      'successful verification': props<{ vddName: string; logicalLink: string }>(),
      'failed verification': props<{
        vddName: string;
        logicalLink: string;
        oldSingleRead: RemoteDiagnosticsSuccessResponseData;
      }>(),
      error: props<{
        vddName: string;
        logicalLinkName: string;
        error: ViError;
      }>(),
    },
  });

  export const setDefaultStateOnTabChange = createAction(
    '[VDD DETAILS LIST] Set default state on tab change'
  );

  export const SetNewValue = createAction(
    '[VDD DETAILS LIST] Set New Value',
    props<{ vddName: string; logicalLink: string; path: string; newValue: string }>()
  );

  export const SetRawSingleReadValues = createAction(
    '[VDD DETAILS LIST] Set Raw Single Read Values',
    props<{
      vddName: string;
      logicalLink: string;
      rawSingleReadValues: RemoteDiagnosticsSuccessResponseData;
    }>()
  );
}
